import React, { Component } from 'react';
import { Fabric } from 'office-ui-fabric-react/lib/Fabric';

export class EmptyLayout extends Component {
  render() {
    return (
      <Fabric>
        {this.props.children}
      </Fabric>
    );
  }
}
